import { render, staticRenderFns } from "./LatestEvents.vue?vue&type=template&id=4279f66c"
import script from "./LatestEvents.vue?vue&type=script&lang=js"
export * from "./LatestEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports